import _extends from "@babel/runtime/helpers/esm/extends";
import defaultLocale from '../locale/default';

var runtimeLocale = _extends({}, defaultLocale.Modal);

export var getModalLocale = function getModalLocale() {
  return _extends({}, runtimeLocale);
};
export var changeModalLocale = function changeModalLocale(locale) {
  runtimeLocale = _extends(_extends({}, runtimeLocale), locale);
};